var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInstagramMobileButtonChevron = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 6,
  height: 11,
  viewBox: "0 0 6 11",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "transparent",
  fillRule: "evenodd",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m.429.571 5.142 4.5-5.142 4.5"
})));
export default SvgInstagramMobileButtonChevron;